import { Module } from 'core/Module';
import { Inertia } from 'utils/motion/Inertia';
import fastdom from 'fastdom';
import { device } from 'utils/device';

export class ParallaxImage extends Module {
	public config = {
		//The amount of overflow as a ratio. i.e 1.2 is equal to 20% on the y
		overflow: 0.2
	};

	private _rect: DOMRect;
	private _innerHeight: number = 0;
	private _inernia: Inertia;
	private _scale: number = 1.2;
	private _visible: boolean = false;
	private _hasActiveWillChange: boolean = false;

	public create(): void {
		this._innerHeight = device.innerHeight;
		this._inernia = new Inertia(20);
		this._inernia.value = 0;
		this._inernia.target = 0;
	}

	public resize(sizes: any): void {
		this._innerHeight = sizes.height;
	}

	public tick(): void {
		if (this._visible) {
			this._inernia.tick();

			fastdom.mutate(() => {
				this.$container.style.transform = `scale(${this.config.overflow}) translateY(${this._inernia.value}px)`;
			});

			if (!this._hasActiveWillChange) {
				fastdom.mutate(() => {
					this.$container.style['will-change'] = 'transform';
				});

				this._hasActiveWillChange = true;
			}

			return;
		}

		if (this._hasActiveWillChange) {
			fastdom.mutate(() => {
				this.$container.style['will-change'] = 'auto';
			});

			this._hasActiveWillChange = false;
		}
	}

	public destroy(): void {
		this._inernia = null;
		this._rect = null;
		console.log('destroy parallax image');
	}

	public scroll(y: number): void {
		fastdom.measure(() => {
			this._rect = this.$container.getBoundingClientRect();

			let lowerY = -1 * this._rect.height;
			this._visible = false;
			if (this._rect.top > lowerY && this._rect.top < this._innerHeight) {
				this._visible = true;

				let rangeHeight = this._innerHeight + this._rect.height;

				let translatedTop = this._rect.top + -1 * lowerY;

				let ratio = 1.0 - translatedTop / rangeHeight;
				let range = ((this.config.overflow - 1) * this._rect.height) / this._scale;
				let y = 1 * (range / 2) - range * ratio;
				this._inernia.target = y;
			}
		});
	}
}
